import { render, staticRenderFns } from "./BtnEnter.vue?vue&type=template&id=25a5b18a&scoped=true"
import script from "./BtnEnter.vue?vue&type=script&lang=js"
export * from "./BtnEnter.vue?vue&type=script&lang=js"
import style0 from "./BtnEnter.vue?vue&type=style&index=0&id=25a5b18a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a5b18a",
  null
  
)

export default component.exports